import { ComponentProps } from 'react';

export interface UnstyledButtonProps extends ComponentProps<'button'> {}

export const UnstyledButton = (props: UnstyledButtonProps) => {
  return (
    <button
      css={{
        display: 'flex',
        background: 'none',
        border: 'none',
        padding: 0,
        font: 'inherit',
        color: 'inherit',
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
      }}
      {...props}
    />
  );
};
